(() => {
  'use strict';

  // Open Shopify's existing preferences UI; consent remains owned by Shopify.
  // https://shopify.dev/docs/api/customer-privacy#showing-the-preferences-modal
  document.addEventListener('click', async (event) => {
    const trigger = event.target.closest('[data-cookie-preferences]');
    if (!trigger || trigger.disabled) return;

    const status = document.getElementById('CookiePreferencesStatus');
    if (status) status.textContent = '';
    trigger.disabled = true;
    trigger.setAttribute('aria-busy', 'true');

    try {
      if (typeof window.privacyBanner?.showPreferences !== 'function') {
        throw new Error('Cookie preferences unavailable');
      }
      await window.privacyBanner.showPreferences();
    } catch {
      if (status) status.textContent = 'Çerez tercihleri açılamadı. Lütfen yeniden deneyin.';
    } finally {
      trigger.disabled = false;
      trigger.removeAttribute('aria-busy');
    }
  });
})();
